// Copyright (c) 2017 Deere & Company

import SpecialAllowanceClaimStatusReport from '@deere/cps-it.warranty-model-factory/lib/special-allowance-claim-status';
import t from 'tcomb';

const Report = t.list(SpecialAllowanceClaimStatusReport, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/state/report.js